export const deepClean = (obj: any): any => {
    if (Array.isArray(obj)) {
      const cleanedArray = obj
        .map(item => deepClean(item))
        .filter(item => {
          if (typeof item === 'object') {
            return Object.keys(item).length > 0;
          }
          return item !== null && item !== "" && item !== undefined;
        });
  
      // Nếu còn lại ít hơn 2 item thì bỏ luôn
      return cleanedArray.length > 1 ? cleanedArray : undefined;
    } else if (typeof obj === 'object' && obj !== null) {
      const cleanedObj: Record<string, any> = {};
      for (const [key, value] of Object.entries(obj)) {
        const cleanedValue = deepClean(value);
        if (
          cleanedValue !== null &&
          cleanedValue !== undefined &&
          (typeof cleanedValue !== 'object' || Object.keys(cleanedValue).length > 0)
        ) {
          cleanedObj[key] = cleanedValue;
        }
      }
      return cleanedObj;
    } else {
      return obj !== "" && obj !== null && obj !== undefined ? obj : undefined;
    }
  }